// Display-time layout only. Never alters, adds or removes the author's words.
const isCapsHeading = (s) => {
  const letters = s.replace(/[^A-Za-z]/g, '');
  return letters.length >= 3 && s === s.toUpperCase() && !s.includes('→') && s.length < 90 && !/^[“"]/.test(s);
};
const isFormula = (s) => s.includes('→');
const isByline = (s) => /^(by|written by)\s+[A-Z][\w.' -]+$/i.test(s);
const short = (s) => s.split(/\s+/).length <= 3;

export const structureIfFlat = (md) => {
  if (!md) return '';
  if (/^#{1,6}\s/m.test(md)) return md;
  const paras = md.split(/\n\s*\n|\n/).map((p) => p.trim()).filter(Boolean);
  const out = [];
  let i = 0;
  while (i < paras.length) {
    const s = paras[i];
    if (isByline(s) && out.length <= 1) { out.push(`*${s}*`); i++; continue; }
    if (isFormula(s) || (isCapsHeading(s) && paras[i + 1]?.startsWith('→'))) {
      const chain = [];
      while (i < paras.length && (isFormula(paras[i]) || (chain.length && paras[i].startsWith('→')) || (!chain.length && isCapsHeading(paras[i])))) {
        chain.push(paras[i]); i++;
      }
      out.push('```formula\n' + chain.join('\n') + '\n```');
      continue;
    }
    if (isCapsHeading(s)) { out.push(`## ${s}`); i++; continue; }
    if (/^[“"]/.test(s) && (/[”"]$/.test(s) || s.length < 160)) { out.push(`> ${s}`); i++; continue; }
    if (short(s) && i + 2 < paras.length && [1, 2].every((k) => short(paras[i + k]) && !isCapsHeading(paras[i + k]) && !isFormula(paras[i + k]))) {
      const stanza = [];
      while (i < paras.length && short(paras[i]) && !isCapsHeading(paras[i]) && !isFormula(paras[i])) { stanza.push(paras[i]); i++; }
      out.push(stanza.join('  \n'));
      continue;
    }
    out.push(s); i++;
  }
  return out.join('\n\n');
};
